import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function ShelmurCarRentalsCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-shelmur-car-rentals"
      eyebrow="Selected work"
      tag="Web"
      liveSiteUrl="https://www.shelmurcarrentals.cc/"
      liveSiteLabel="Visit Shelmur Car Rentals"
      title="Shelmur Car Rentals — Booking-First Rental Experience"
      summary="A full marketing and booking-focused site for a car rental brand—strong visual hierarchy, vehicle-led hero, and a streamlined path to reserve a car."
      image="/Shelmur.png"
      imageAlt="Shelmur Car Rentals website hero and booking section"
      sections={[
        {
          title: "The brief",
          body: "Present a trustworthy, modern rental brand online: highlight the fleet, reduce friction, and make it obvious how to book—especially on mobile.",
        },
        {
          title: "What we built",
          body: "A responsive site with a high-impact hero, clear calls-to-action, and structured content that guides users from discovery to booking details.",
        },
        {
          title: "Outcome",
          body: "A cohesive brand presence on the web that aligns with the rental experience—professional, fast to scan, and easy to act on.",
        },
      ]}
      tech={["React", "Responsive UI", "UX/UI", "Figma"]}
      results={[
        "Booking-focused layout",
        "Mobile-friendly experience",
        "Clear brand presentation",
        "Fast scan-to-action",
      ]}
    />
  )
}
